var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cube-header',_vm._b({attrs:{"av-if":"$route.meta.signatureForm !== true"}},'cube-header',_vm.$route.meta.headerConfig,false)),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }